import React from "react";
import "./App.css";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Industries from "./components/industries/Industries";
import Skills from "./components/skills/Skills";
// import Qualification from "./components/qualification/Qualification";
import Work from "./components/work/Work";
import Faq from "./components/faq/Faq";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <>
      <Header />
      <main className="main">
        <Home />
        <Industries />
        <Skills />
        {/* <Qualification /> */}
        <Work />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>

  );
}

export default App;
